import React, { Fragment, useEffect, useRef } from 'react';
import { translate } from '../Services/translation';

const NavigationItem = ({ links = [], contentLink = null }) => {
    const menuRef = useRef(null);
    const menuCourtain = useRef(null);
    const menuTriggerRef = useRef(null);

    const toplinksWrapper = document.querySelector('.header__toplinks--wrapper');

    const toggleMenu = (e) => {
        e.preventDefault();
        menuRef.current.classList.toggle('navbar__menu--show');
        document.body.classList.toggle('no-scroll-mobile');
        menuCourtain.current.classList.toggle('show');
        menuTriggerRef.current.classList.toggle('expanded');
    };

    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;


    useEffect(() => {
        function handleScroll() {
            if (window.scrollY > 0) {
                if (!toplinksWrapper?.classList?.contains('scrolled'))
                    toplinksWrapper?.classList.add('scrolled');
            } else {
                    toplinksWrapper?.classList.remove('scrolled');
            }
        }

        document.addEventListener('scroll', handleScroll);

        return () => {
            document.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <Fragment>
            {!contentLink ? (
                <a
                    className="navbar__link--block navbar__icon--menu navbar__icon"
                    onClick={toggleMenu}
                    rel="nofollow"
                    href="#"
                    title={translate('general.menu') || 'menu'}
                    ref={menuTriggerRef}
                ></a>
            ) : (
                <Fragment>
                    <a
                        className={`navbar__link ${selectedClass} ${
                            hasChildrenClass || ''
                        } ${additionClass || ''}`}
                        href={contentLink.url || '#'}
                        dangerouslySetInnerHTML={{ __html: contentLink.name }}
                        ref={menuTriggerRef}
                    ></a>

                    {links.length > 0 && (
                        <i
                            className="navbar__icon--caret-right navbar__icon navbar__icon--open"
                            onClick={toggleMenu}
                        ></i>
                    )}
                </Fragment>
            )}

            {links.length > 0 && (
                <Fragment>
                    <div className="navbar__courtain" onClick={toggleMenu} ref={menuCourtain}></div>
                    <ul className="navbar__menu" ref={menuRef}>
                        <li className="navbar__menu-header">
                            {!contentLink ? (
                                <span
                                    className="navbar__icon navbar__icon--close"
                                    onClick={toggleMenu}
                                ></span>
                            ) : (
                                <Fragment>
                                    <i
                                        className="navbar__icon--caret-left navbar__icon"
                                        onClick={toggleMenu}
                                    ></i>
                                    <span
                                        className="navbar__title"
                                        onClick={toggleMenu}
                                        dangerouslySetInnerHTML={{
                                            __html: contentLink.name,
                                        }}
                                    ></span>
                                </Fragment>
                            )}
                        </li>
                        {links.length > 0 &&
                            links.map(
                                (link, index) =>
                                    hasNameOrChildren(link) && (
                                        <li
                                            className="navbar__item"
                                            key={index}
                                        >
                                            <NavigationItem
                                                links={link.links}
                                                contentLink={link}
                                            />
                                        </li>
                                    )
                            )}
                    </ul>
                </Fragment>
            )}
        </Fragment>
    );
};

export default NavigationItem;
